import { IQuote } from 'components/WatchBox/components/CompactView';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import { colors, styled } from '../../../assets/theme';
import { DataContainer, LabeledText, NormalText } from '../../../assets/theme/StyledComponents';

interface ITickerProps {
  id: number,
  label: string,
  symbol: string,
  yieldSymbol?: string,
  flow: string
}

export const bondPriceConvert = (currentPrice: number, conversionFactor: number = 32) => {
  const thousanths = currentPrice % 1
  let price = thousanths * 32
  switch (conversionFactor) {
    case 32:
      price = Math.round(price) * 10
      break;
    case 64:
      price = price * 10
      price = Math.round(price / 5) * 5;
      break;
  }
  let thous = Math.round(price).toString()
  // let thous = (Math.round((Number((currentPrice % 1).toFixed(4)) * conversionFactor)) * 10).toString();
  while (thous.length < 3) {thous = '0' + thous};
  return Number(Math.floor(currentPrice).toString() + thous);
}

const Ticker: React.FunctionComponent<ITickerProps> = ({ id, label, symbol, yieldSymbol, flow }) => {
  const [quote, setQuote] = useState<IQuote>();
  const [quoteYield, setQuoteYield] = useState<IQuote>();

  useEffect(() => {
    if (yieldSymbol) {
      subscribeListener(`sym:${yieldSymbol}:tick`, id, ({ data }) => {
        setQuoteYield(data);
      });
      return () => unsubscribeListener(`sym:${yieldSymbol}:tick`, id);
    }
    return () => { /* do nothing */ };
  }, [id, yieldSymbol]);

  useEffect(() => {
    subscribeListener(`sym:${symbol}:tick`, id, ({ data }) => {
      setQuote(data);
    });
    return () => unsubscribeListener(`sym:${symbol}:tick`, id);
  }, [id, symbol]);

  if (!quote) { return <div /> };

  const { p, nc } = quote;
  if (p === undefined || nc === undefined) { return <div /> }
  const [indicator, color] = nc > 0 ? ['+', colors.accents.good.base] : ['', colors.accents.bad.base];

  return (
    <TickerContainer flowDirection={flow}>
      <StockPriceLabel>{label}</StockPriceLabel>
      <StockPriceChangeWrapper>
        { p !== null ?
          (symbol === 'ZN' || symbol === 'ZB') ?
          <NumberFormat
            value={bondPriceConvert(p, symbol === 'ZB' ? 32 : 64)}
            displayType="text"
            fixedDecimalScale={true}
            decimalScale={0}
          />
          :
          <NumberFormat
            value={p}
            displayType="text"
            thousandSeparator={true}
            fixedDecimalScale={true}
            decimalScale={2}
          />
          :
          <br />
        }
      </StockPriceChangeWrapper>
      <StockPriceChangeWrapper fontColor={color}>
        { nc !== null ?
        <div>
          <NumberFormat
            value={nc}
            prefix={indicator}
            displayType="text"
            thousandSeparator={true}
            fixedDecimalScale={true}
            decimalScale={2}
          />
          (<NumberFormat
            value={p !== nc ? 100 * nc / (p - nc) : 0}
            prefix={indicator}
            displayType="text"
            thousandSeparator={true}
            fixedDecimalScale={true}
            decimalScale={2}
            suffix="%"
          />)
        </div>
          :
          <br />
        }
      </StockPriceChangeWrapper>
      {
        yieldSymbol ?
        quoteYield && quoteYield.yld ?
        <StockPriceChangeWrapper fontColor={quoteYield.yld > 0 ? colors.accents.good.base : colors.accents.bad.base}>
            <NumberFormat
              value={quoteYield.yld}
              displayType="text"
              thousandSeparator={true}
              fixedDecimalScale={true}
              decimalScale={2}
              suffix="%"
            />
        </StockPriceChangeWrapper>
            :
            <StockPriceChangeWrapper>
              <span> - %</span>
            </StockPriceChangeWrapper>
            :
          <div />
      }
    </TickerContainer>
  );
};

const StockPriceLabel = styled(LabeledText)`
  font-size: 1em;
`;

const StockPriceChangeWrapper = styled(NormalText)<{ fontColor?: string}>`
  color: ${({ theme, fontColor }) => fontColor ? fontColor : theme.core.textColor};
  font-size: 0.8em;
`;

const TickerContainer = styled(DataContainer)<{flowDirection: string}>`
  display: grid;
  justify-items: center;
  min-width: 94px;
  margin: 3px;
  background: ${({ theme }) => theme.core.alternateBackground};
  border-radius: 3px;
  padding: 3px;
  grid-auto-flow: ${({ flowDirection }) => flowDirection};
  grid-gap: ${({ flowDirection }) => flowDirection === 'column' ? '1em' : '0em'};
  align-items: center;
`;

export default Ticker;
